<template>
    <div>
        <div><i class="material-icons">sentiment_very_satisfied</i></div>
        <h3>Takk for aksept!</h3>
        <p>Før vi ingangsetter<br> reparasjonsprosessen trenger vi et<br> PO-nummer</p>
        <div>
            <input @keyup.enter="send()" v-model="po_number" type="text"/>
            <span class="v-error" v-if="localErrors.po_number" v-text="localErrors.po_number"></span>
        </div>
        <div>
            <button @click.prevent="send()">Send inn</button>
        </div>
    </div>
</template>

<script>

import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

export default {
  data () {
    return {
        po_number: "",
        validate: false
    }
  },
  mixins: [VuejsDialogMixin],
  computed: {
      localErrors(){
          if(this.validate){
              var e = {};
              let po_number = this.po_number.trim();
              if(!po_number.match(/\d{7}\d*/gi))
                  e.po_number = 'Nummer må fylles ut';
              return e;
          }else{
              return {};
          }
      }
  },
  methods: {
      send(){
        this.validate = true;
        if(!this.validateAccept()) return;
        this.proceed(this.po_number);
      },
      validateAccept(){
          this.validate = true;

          if(Object.keys(this.localErrors).length)
              return false;

          return true;
      },
  }
}
</script>

<style lang="scss">
    .v-error{
        color: red;
        text-align: right;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// AcceptOffer.vue?216ab964